import { Component, OnInit, inject } from '@angular/core';
import { NotificationManagementService } from '../../services/notification-management.service';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    standalone: false
})
export class NotificationComponent implements OnInit {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private notificationManagementService = inject(NotificationManagementService);


  records: any[] = [];
  totalCount: any = 0;
  isHome = true;

  ngOnInit(): void {

    this.notificationManagementService.getkeyValueList(0, 10, this.isHome).subscribe(
      (res) => {
        this.totalCount = (res as any)["count"];
        this.records = (res as any)["docs"];
      }, (err) => {
        this.logger.exception(err)
      }
    );
  }

}
